import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Busonhireinshirdi() {



    const cardData = {





keyword: "Bus on Hire in Shirdi",

headingDescription: "Sai Shirdi Cab offers comfortable and dependable Bus on Hire in Shirdi for devotees, families, school and college groups, corporate teams, tour groups, wedding guests, and large parties traveling for pilgrimage, sightseeing, events, and outstation journeys. Customers can choose a suitable bus or large-capacity vehicle according to group size, luggage requirements, trip duration, and travel itinerary. Bus hire is useful for Shirdi darshan, Maharashtra pilgrimage tours, family functions, corporate travel, group sightseeing, one-way transportation, round trips, and multi-day tours. With experienced drivers, well-maintained vehicles, comfortable seating, adequate luggage space, flexible pickup and drop arrangements, and customized travel plans, Sai Shirdi Cab helps large groups travel together conveniently instead of arranging multiple smaller vehicles. Customers can plan direct journeys or multi-destination tours across Maharashtra with transportation arranged according to their preferred schedule.",

topPlaces: [
  {
    title: "Shani Shingnapur",
    description: "Shani Shingnapur is one of the most popular pilgrimage destinations near Shirdi and is frequently included in group religious tours. Hiring a bus makes the journey convenient for families, devotees, and large groups traveling together. Customers can plan a same-day visit or include Shani Shingnapur as one stop in a longer Maharashtra pilgrimage itinerary."
  },
  {
    title: "Grishneshwar",
    description: "Grishneshwar is a major pilgrimage destination and one of the twelve revered Jyotirlinga shrines in Maharashtra. Large groups visiting from Shirdi can hire a bus for comfortable transportation to the temple and nearby attractions. Group travel is especially convenient when passengers want to stay together throughout the pilgrimage without arranging separate vehicles."
  },
  {
    title: "Ellora Caves",
    description: "Ellora Caves are an important heritage attraction near Grishneshwar and can be combined with a Shirdi pilgrimage tour. A hired bus provides practical transportation for families, school groups, tour groups, and larger parties visiting the ancient rock-cut monuments. The itinerary can be customized to include Ellora along with other nearby destinations."
  },
  {
    title: "Nashik",
    description: "Nashik is a major religious, commercial, and cultural destination that can be included in a group tour from Shirdi. Hiring a bus allows everyone to travel together while carrying luggage comfortably. Customers can plan temple visits, sightseeing, family trips, or multi-day Maharashtra tours with flexible pickup and destination arrangements."
  },
  {
    title: "Trimbakeshwar",
    description: "Trimbakeshwar is a prominent Jyotirlinga pilgrimage destination near Nashik and is suitable for group religious tours from Shirdi. Families and devotees can hire a bus for convenient transportation between temples and nearby sightseeing locations. Sai Shirdi Cab can arrange suitable group transportation according to passenger numbers and travel duration."
  },
  {
    title: "Saptashrungi Gad",
    description: "Saptashrungi Gad is an important Shakti pilgrimage destination near Nashik and attracts devotees throughout the year. Large groups can hire a bus from Shirdi for a comfortable and organized temple visit. The journey can be customized with additional religious stops and convenient return arrangements according to the group's schedule."
  },
  {
    title: "Chhatrapati Sambhajinagar",
    description: "Chhatrapati Sambhajinagar is a major heritage and cultural destination with historic monuments, temples, and nearby attractions. Groups traveling from Shirdi can hire a bus for sightseeing, pilgrimage, educational tours, or family travel. Spacious group transportation makes it easier for everyone to travel together with luggage during multi-day trips."
  },
  {
    title: "Pune",
    description: "Pune is a major business and educational city and can be included in a longer group journey from Shirdi. Bus hire is useful for corporate teams, educational groups, family functions, and tour parties requiring coordinated transportation. Customers can arrange direct travel or combine Pune with additional Maharashtra destinations."
  },
  {
    title: "Mumbai",
    description: "Mumbai is a major metropolitan destination that can be reached from Shirdi by comfortable group transportation. Hiring a bus is a practical option for corporate teams, families, tour groups, and event travelers who prefer to stay together throughout the journey. Flexible pickup and drop arrangements can be planned around the group's itinerary."
  },
  {
    title: "Mahabaleshwar",
    description: "Mahabaleshwar is a popular hill station known for viewpoints, valleys, waterfalls, lakes, and strawberry farms. Large families and tour groups can hire a bus from Shirdi for a comfortable holiday or sightseeing trip. Customers can also include Panchgani and nearby attractions in a customized multi-day itinerary."
  },
  {
    title: "Kolhapur",
    description: "Kolhapur is an important religious and cultural city known for the Mahalaxmi Temple, historic attractions, and regional heritage. Groups traveling from Shirdi can hire a bus for pilgrimage tours, family journeys, and sightseeing. Group transportation allows passengers to travel together with sufficient seating and luggage capacity."
  }
],




"services": [
{
"name": "14 17 25 32 Seater Bus on Rent in Shirdi",
"description": "14 17 25 32 Seater Bus on Rent in Shirdi provides convenient group transportation for pilgrims, families, corporate groups, and tour parties. Different seating capacities can be selected according to the group size, luggage requirements, sightseeing plans, and travel schedule."
},
{
"name": "14 Seater Tempo Traveller on Rent",
"description": "14 Seater Tempo Traveller on Rent is suitable for small and medium-sized groups traveling from Shirdi. The vehicle can be arranged for Sai Baba Darshan, local sightseeing, nearby pilgrimage destinations, family trips, and outstation journeys."
},
{
"name": "17 Seater Tempo Traveller on Rent Shirdi",
"description": "17 Seater Tempo Traveller on Rent Shirdi offers spacious group travel for pilgrims and tourists visiting Shirdi and nearby destinations. It can be used for temple tours, family journeys, sightseeing packages, railway station transfers, and multi-day travel."
},
{
"name": "25 Seater Tempo Traveller on Rent Shirdi",
"description": "25 Seater Tempo Traveller on Rent Shirdi provides comfortable transportation for larger groups planning pilgrimage and sightseeing tours. The vehicle can be booked for Shirdi Darshan, Shani Shingnapur visits, Nashik tours, Ajanta Ellora trips, and other outstation routes."
},
{
"name": "32 Seater Tempo Traveller on Rent Shirdi",
"description": "32 Seater Tempo Traveller on Rent Shirdi is designed for large groups requiring dedicated transportation during their trip. It can be arranged for religious tours, family gatherings, group sightseeing, corporate travel, and multi-destination journeys from Shirdi."
},
{
"name": "14 17 25 32 Seater Mini Bus on Rent in Shirdi",
"description": "14 17 25 32 Seater Mini Bus on Rent in Shirdi provides multiple vehicle choices for group transportation. Travelers can select a suitable seating capacity for temple Darshan, local sightseeing, family tours, pilgrimage packages, and long-distance travel."
},
{
"name": "Tempo Traveller Hire in Shirdi",
"description": "Tempo Traveller Hire in Shirdi offers spacious private transportation for groups visiting Sai Baba Temple and surrounding destinations. Vehicles can be arranged for one-day tours, outstation journeys, pilgrimage trips, sightseeing packages, and multi-day itineraries."
},
{
"name": "Shirdi Airport Minibus Hire",
"description": "Shirdi Airport Minibus Hire provides group transportation for passengers arriving at or departing from Shirdi Airport. Minibuses can be arranged for hotel transfers, Sai Baba Darshan, group airport pickups, railway station connections, and onward travel."
},
{
"name": "Tempo Traveller on Rent in Shirdi Airport",
"description": "Tempo Traveller on Rent in Shirdi Airport is suitable for families and groups requiring spacious transportation after arriving at Shirdi Airport. The vehicle can be used for hotel transfers, Sai Baba Temple visits, local sightseeing, and outstation destinations."
},
{
"name": "32 Seater Bus Hire in Shirdi",
"description": "32 Seater Bus Hire in Shirdi provides dedicated group transportation for pilgrimage tours, sightseeing trips, family functions, and organized travel. The bus can be planned for local Shirdi routes as well as longer journeys to nearby cities and religious destinations."
},
{
"name": "14 17 25 32 Seater Tempo Traveller on Rent",
"description": "14 17 25 32 Seater Tempo Traveller on Rent provides flexible seating options for groups of different sizes. These vehicles can be arranged for Shirdi Darshan, temple tours, sightseeing packages, airport transfers, and outstation travel."
},
{
"name": "Shirdi Airport to Nashik Tempo Traveller",
"description": "Shirdi Airport to Nashik Tempo Traveller provides spacious group transportation between Shirdi Airport and Nashik. The vehicle can be arranged for families, pilgrimage groups, corporate travelers, and tourists requiring convenient travel with luggage."
},
{
"name": "Shirdi to Ajanta Ellora Tempo Traveller on Rent",
"description": "Shirdi to Ajanta Ellora Tempo Traveller on Rent is suitable for groups combining Sai Baba Darshan with heritage sightseeing. The journey can be planned to cover Ajanta and Ellora Caves with comfortable group transportation, flexible stops, and return or onward travel."
},
{
"name": "32 35 40 45 50 Seater Bus on Rent in Shirdi",
"description": "32 35 40 45 50 Seater Bus on Rent in Shirdi provides larger bus options for organized groups and tour operators. Seating capacity can be selected according to passenger strength for pilgrimage tours, sightseeing programs, corporate travel, and extended journeys."
},
{
"name": "14-Seater Bus on Rent Shirdi",
"description": "14-Seater Bus on Rent Shirdi offers a practical group travel option for smaller tour parties. It can be arranged for Sai Baba Darshan, Shirdi local sightseeing, nearby temples, airport transfers, railway station pickups, and short outstation trips."
},
{
"name": "17-Seater Bus on Rent Shirdi",
"description": "17-Seater Bus on Rent Shirdi provides comfortable transportation for medium-sized groups traveling together. The bus can be used for pilgrimage tours, family trips, sightseeing programs, temple visits, and outstation journeys from Shirdi."
},
{
"name": "20-Seater Bus on Rent Shirdi",
"description": "20-Seater Bus on Rent Shirdi is suitable for groups requiring more seating capacity for organized travel. It can be booked for Sai Baba Darshan, religious tours, sightseeing, family travel, airport transfers, and multi-day group itineraries."
},
{
"name": "25-Seater Bus on Rent Shirdi",
"description": "25-Seater Bus on Rent Shirdi provides spacious transportation for larger families, pilgrimage groups, and tour parties. The vehicle can be arranged for Shirdi Darshan, Shani Shingnapur, Nashik, Saptashrungi, and other sightseeing destinations."
},
{
"name": "28-Seater Bus on Rent Shirdi",
"description": "28-Seater Bus on Rent Shirdi offers dedicated transportation for medium to large groups planning religious or sightseeing journeys. It can be used for local tours, outstation travel, temple visits, family functions, and customized multi-day trips."
},
{
"name": "30-Seater Bus on Rent Shirdi",
"description": "30-Seater Bus on Rent Shirdi provides convenient group transportation for organized tours and pilgrimage journeys. The bus can cover Sai Baba Temple, nearby religious places, sightseeing destinations, airport transfers, and longer routes according to the itinerary."
},
{
"name": "32-Seater Bus on Rent Shirdi",
"description": "32-Seater Bus on Rent Shirdi is suitable for large groups traveling together for pilgrimage, sightseeing, and family tours. Private bus arrangements can be planned for Shirdi Darshan, nearby temples, outstation destinations, and multi-day travel."
},
{
"name": "35-Seater Bus on Rent Shirdi",
"description": "35-Seater Bus on Rent Shirdi provides spacious group transportation for larger pilgrimage parties and tour groups. It can be arranged for Shirdi temple visits, religious circuits, sightseeing tours, airport transfers, and extended outstation journeys."
},
{
"name": "36-Seater Bus on Rent Shirdi",
"description": "36-Seater Bus on Rent Shirdi offers comfortable transportation for sizable groups requiring dedicated travel arrangements. The bus can be used for pilgrimage tours, sightseeing programs, family events, corporate travel, and multi-location itineraries."
},
{
"name": "40-Seater Bus on Rent Shirdi",
"description": "40-Seater Bus on Rent Shirdi is designed for large groups planning organized travel from Shirdi. It can be booked for Sai Baba Darshan, religious tours, sightseeing circuits, family functions, and long-distance group transportation."
},
{
"name": "45-Seater Bus on Rent Shirdi",
"description": "45-Seater Bus on Rent Shirdi provides high-capacity transportation for large pilgrimage groups, tour parties, and organized travelers. The bus can support Shirdi Darshan, multi-temple tours, sightseeing packages, airport transfers, and outstation journeys."
},
{
"name": "49-Seater Bus on Rent Shirdi",
"description": "49-Seater Bus on Rent Shirdi offers a convenient solution for large groups traveling together. It can be arranged for pilgrimage programs, Shirdi sightseeing, religious tours, group events, corporate travel, and multi-day outstation itineraries."
},
{
"name": "50-Seater Bus on Rent Shirdi",
"description": "50-Seater Bus on Rent Shirdi provides spacious group transportation for large tour parties and pilgrimage groups. The bus can be planned for Sai Baba Darshan, Shani Shingnapur, Nashik, Jyotirlinga tours, heritage sightseeing, and longer journeys."
},
{
"name": "54-Seater Bus on Rent Shirdi",
"description": "54-Seater Bus on Rent Shirdi is suitable for very large groups requiring dedicated transportation for religious and sightseeing programs. It can be arranged for temple tours, group events, corporate travel, airport transfers, and multi-day journeys."
},
{
"name": "55-Seater Bus on Rent Shirdi",
"description": "55-Seater Bus on Rent Shirdi provides high-capacity travel for large organized groups visiting Shirdi and surrounding destinations. The bus can be used for pilgrimage tours, sightseeing circuits, family gatherings, corporate programs, and extended travel plans."
},
{
"name": "Bus for Shirdi Darshan",
"description": "Bus for Shirdi Darshan provides group transportation for devotees traveling to Sai Baba Temple. Suitable bus sizes can be arranged according to the number of passengers, with transportation options for temple visits, hotel transfers, railway stations, and local sightseeing."
},
{
"name": "Bus Hire for Sai Baba Darshan",
"description": "Bus Hire for Sai Baba Darshan offers dedicated group transportation for pilgrims visiting Shirdi. The bus can be arranged from nearby cities or pickup points and used for Sai Baba Temple travel, local sightseeing, hotel transfers, and return journeys."
},
{
"name": "Shirdi Pilgrimage Bus Rental",
"description": "Shirdi Pilgrimage Bus Rental provides spacious transportation for groups planning religious journeys around Shirdi. Buses can be arranged for Sai Baba Darshan, Shani Shingnapur, Saptashrungi, Nashik, Trimbakeshwar, and other pilgrimage destinations."
},
{
"name": "Bus for Shirdi and Shani Shingnapur",
"description": "Bus for Shirdi and Shani Shingnapur provides convenient group transportation for devotees visiting both important religious destinations. The itinerary can be customized for same-day travel or extended pilgrimage tours with suitable bus capacity."
},
{
"name": "Shirdi Saptashrungi Bus Rental",
"description": "Shirdi Saptashrungi Bus Rental offers group transportation for pilgrims traveling from Shirdi to Saptashrungi Devi Temple and Vani. The bus can be arranged for families and larger groups requiring comfortable travel for a same-day or customized pilgrimage itinerary."
},
{
"name": "Shirdi Ajanta Ellora Bus Package",
"description": "Shirdi Ajanta Ellora Bus Package combines Sai Baba Darshan with heritage sightseeing at Ajanta and Ellora. Group bus transportation can be arranged for multi-day journeys with planned sightseeing stops, hotel transfers, luggage requirements, and return travel."
},
{
"name": "Shirdi Ashtavinayak Darshan Bus",
"description": "Shirdi Ashtavinayak Darshan Bus provides group transportation for devotees planning a visit to the eight Ashtavinayak temples of Maharashtra. The journey can be arranged over multiple days with suitable bus capacity for families, pilgrimage groups, and tour parties."
},
{
"name": "Shirdi Jyotirlinga Darshan Bus",
"description": "Shirdi Jyotirlinga Darshan Bus is suitable for groups planning a religious tour covering important Jyotirlinga temples in Maharashtra. Bus transportation can be arranged for routes involving Bhimashankar, Trimbakeshwar, Grishneshwar, and other pilgrimage destinations."
}
],
"tableData": [
["14 17 25 32 Seater Bus on Rent in Shirdi", "14 Seater Tempo Traveller on Rent"],
["17 Seater Tempo Traveller on Rent Shirdi", "25 Seater Tempo Traveller on Rent Shirdi"],
["32 Seater Tempo Traveller on Rent Shirdi", "14 17 25 32 Seater Mini Bus on Rent in Shirdi"],
["Tempo Traveller Hire in Shirdi", "Shirdi Airport Minibus Hire"],
["Tempo Traveller on Rent in Shirdi Airport", "32 Seater Bus Hire in Shirdi"],
["14 17 25 32 Seater Tempo Traveller on Rent", "Shirdi Airport to Nashik Tempo Traveller"],
["Shirdi to Ajanta Ellora Tempo Traveller on Rent", "32 35 40 45 50 Seater Bus on Rent in Shirdi"],
["14-Seater Bus on Rent Shirdi", "17-Seater Bus on Rent Shirdi"],
["20-Seater Bus on Rent Shirdi", "25-Seater Bus on Rent Shirdi"],
["28-Seater Bus on Rent Shirdi", "30-Seater Bus on Rent Shirdi"],
["32-Seater Bus on Rent Shirdi", "35-Seater Bus on Rent Shirdi"],
["36-Seater Bus on Rent Shirdi", "40-Seater Bus on Rent Shirdi"],
["45-Seater Bus on Rent Shirdi", "49-Seater Bus on Rent Shirdi"],
["50-Seater Bus on Rent Shirdi", "54-Seater Bus on Rent Shirdi"],
["55-Seater Bus on Rent Shirdi", "Bus for Shirdi Darshan"],
["Bus Hire for Sai Baba Darshan", "Shirdi Pilgrimage Bus Rental"],
["Bus for Shirdi and Shani Shingnapur", "Shirdi Saptashrungi Bus Rental"],
["Shirdi Ajanta Ellora Bus Package", "Shirdi Ashtavinayak Darshan Bus"],
["Shirdi Jyotirlinga Darshan Bus", "Shirdi Pilgrimage Bus Rental"]
],










        whychoose: [
            { 
                WhyChooseheading: "Spacious Bus on Hire in Shirdi for Groups", 
                WhyChoosedescription: "Sai Shirdi Cabs provides bus rental arrangements in Shirdi for pilgrimage groups, families, school groups, corporate teams, tour groups, and other larger parties. Hiring a bus allows everyone to travel together while keeping group transportation easier to coordinate." 
            }, 
            { 
                WhyChooseheading: "Suitable for Shirdi Pilgrimage Groups", 
                WhyChoosedescription: "Groups visiting Sai Baba Temple can hire a bus for temple travel, hotel transfers, railway station pickups, airport transportation, and nearby pilgrimage destinations. A dedicated group vehicle helps avoid the need to arrange multiple cars." 
            }, 
            { 
                WhyChooseheading: "Different Seating Capacities", 
                WhyChoosedescription: "Choose a suitable bus option according to your group size and travel requirements. Seating capacity can be discussed during booking so that the vehicle provides an appropriate arrangement for passengers, luggage, and the planned journey." 
            }, 
            { 
                WhyChooseheading: "Convenient for Family & Friends Tours", 
                WhyChoosedescription: "Large families and groups of friends can travel together in a hired bus for Shirdi Darshan and sightseeing. Keeping the group in one vehicle makes it easier to coordinate departure times, stops, and the overall itinerary." 
            }, 
            { 
                WhyChooseheading: "Useful for Local & Outstation Trips", 
                WhyChoosedescription: "A hired bus can be arranged for local Shirdi travel as well as outstation pilgrimage tours and group journeys. Discuss your destinations, trip duration, passenger count, and preferred vehicle size when planning the booking." 
            }, 
            { 
                WhyChooseheading: "Ideal for Multi-Destination Pilgrimage Tours", 
                WhyChoosedescription: "Groups can plan a longer pilgrimage itinerary covering Shirdi along with nearby religious destinations such as Shani Shingnapur, Saptashrungi, Grishneshwar, Trimbakeshwar, or other selected locations." 
            }, 
            { 
                WhyChooseheading: "Comfortable Group Travel with Luggage", 
                WhyChoosedescription: "Travelling together in a dedicated bus can make it easier for larger groups carrying bags, personal belongings, and pilgrimage essentials. Vehicle selection can be planned according to the group's luggage and seating requirements." 
            }, 
            { 
                WhyChooseheading: "Book Bus on Hire in Shirdi with Sai Shirdi Cabs", 
                WhyChoosedescription: "Share your travel date, pickup location, destinations, passenger count, luggage requirements, trip duration, and preferred seating capacity with Sai Shirdi Cabs to arrange a suitable bus rental for your group." 
            } 
        ] 
 
    }; 
 
    const faqData = [ 
        { 
            question: "Can I hire a bus in Shirdi?", 
            answer: "Yes, Sai Shirdi Cabs provides bus rental arrangements in Shirdi for pilgrimage groups, families, school groups, corporate teams, tourists, and larger travel parties." 
        }, 
        { 
            question: "Is a hired bus suitable for Shirdi pilgrimage groups?", 
            answer: "Yes, hiring a bus can be convenient for larger groups visiting Sai Baba Temple because everyone can travel together instead of arranging multiple smaller vehicles." 
        }, 
        { 
            question: "What group sizes can book a bus in Shirdi?", 
            answer: "Bus options can be selected according to the number of passengers and required seating capacity. Share your group size during booking to discuss a suitable vehicle." 
        }, 
        { 
            question: "Can I hire a bus for Sai Baba Darshan?", 
            answer: "Yes, a bus can be arranged for group transportation related to Sai Baba Darshan, including hotel transfers, local travel, railway station pickups, and other planned movements." 
        }, 
        { 
            question: "Can I hire a bus for Shirdi sightseeing?", 
            answer: "Yes, groups can hire a bus for Shirdi sightseeing and discuss additional nearby attractions according to their itinerary and available travel time." 
        }, 
        { 
            question: "Can I use a hired bus for an outstation pilgrimage tour?", 
            answer: "Yes, bus rental arrangements can be requested for outstation pilgrimage tours and multi-destination journeys starting from or passing through Shirdi." 
        }, 
        { 
            question: "Can Shani Shingnapur be included in a Shirdi bus tour?", 
            answer: "Yes, Shani Shingnapur can be included in a group pilgrimage itinerary along with Shirdi, subject to the selected route, travel duration, and overall tour plan." 
        }, 
        { 
            question: "Can I carry luggage in a hired bus?", 
            answer: "Yes, passengers can carry luggage according to the available storage capacity of the selected bus. Larger or additional baggage requirements should be discussed during booking." 
        }, 
        { 
            question: "Can I hire a bus for multiple days in Shirdi?", 
            answer: "Yes, multi-day bus rental can be arranged for extended pilgrimage tours, family trips, sightseeing journeys, and multi-destination group travel." 
        }, 
        { 
            question: "How can I book a bus on hire in Shirdi with Sai Shirdi Cabs?", 
            answer: "Share your travel date, pickup location, destinations, passenger count, luggage details, trip duration, and required seating capacity with Sai Shirdi Cabs to arrange a suitable bus for your group." 
        } 
    ]; 
 
    const testimonials = [ 
        { 
            id: 1, 
            name: "Mr. Ramesh Jagtap", 
            feedback: "Our large family group hired a bus for a Shirdi pilgrimage. Having everyone travel together made it much easier to coordinate the temple visit, hotel transfers, and our nearby sightseeing plans.", 
            rating: 5 
        }, 
        { 
            id: 2, 
            name: "Mrs. Vaishali More", 
            feedback: "We organized a group trip to Shirdi with several families and needed one vehicle for everyone. The hired bus was a practical choice because we could travel together with our luggage.", 
            rating: 5 
        } 
    ];







    const Images = [
        { place: "/images/keyword/1.jpg", text: "Nagarsol to Shirdi Cab", link: "Nagarsol-to-Shirdi-Cab" },
        { place: "/images/keyword/2.jpg", text: "Shirdi Cab Service", link: "Shirdi-Cab-Service" },
        { place: "/images/keyword/3.jpg", text: "Shirdi to Shani Shingnapur Cab", link: "Shirdi-to-Shani-Shingnapur-Cab" },
        { place: "/images/keyword/4.jpg", text: "Shirdi to Grishneshwar Cab", link: "Shirdi-to-Grishneshwar-Cab" },
        { place: "/images/keyword/5.jpg", text: "Shirdi to Manmad Cab", link: "Shirdi-to-Manmad-Cab" },
        { place: "/images/keyword/6.jpg", text: "Shirdi to Lonavala Cab", link: "Shirdi-to-Lonavala-Cab" },
        { place: "/images/keyword/7.jpg", text: "Shirdi to Mahabaleshwar Cab", link: "Shirdi-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/8.jpg", text: "Shirdi to Ashtavinayak Darshan Package", link: "Shirdi-to-Ashtavinayak-Darshan-Package" },
        { place: "/images/keyword/9.jpg", text: "Shirdi to Saptashrungi Cab", link: "Shirdi-to-Saptashrungi-Cab" },
        { place: "/images/keyword/10.jpg", text: "Shirdi Tour Package", link: "Shirdi-Tour-Package" },
        { place: "/images/keyword/11.jpg", text: "Best Taxi Service in Shirdi", link: "Best-Taxi-Service-in-Shirdi" },
        { place: "/images/keyword/12.jpg", text: "Shirdi Airport Cab Service", link: "Shirdi-Airport-Cab-Service" },
        { place: "/images/keyword/13.jpg", text: "Online Cab Booking Shirdi", link: "Online-Cab-Booking-Shirdi" },
        { place: "/images/keyword/14.jpg", text: "Best Travel Agency in Shirdi", link: "Best-Travel-Agency-in-Shirdi" },
        { place: "/images/keyword/15.jpg", text: "Shirdi to Mumbai Airport Cab", link: "Shirdi-to-Mumbai-Airport-Cab" },
        { place: "/images/keyword/16.jpg", text: "Kopargaon to Shirdi Cab", link: "Kopargaon-to-Shirdi-Cab" },
        { place: "/images/keyword/17.jpg", text: "Innova on Rent in Shirdi", link: "Innova-on-Rent-in-Shirdi" },
        { place: "/images/keyword/18.jpg", text: "Shirdi Sightseeing Cab", link: "Shirdi-Sightseeing-Cab" },
        { place: "/images/keyword/19.jpg", text: "Shirdi Darshan Taxi", link: "Shirdi-Darshan-Taxi" },
        { place: "/images/keyword/20.jpg", text: "Bus on Hire in Shirdi", link: "Bus-on-Hire-in-Shirdi" },
        { place: "/images/keyword/21.jpg", text: "Best Sedan Cab in Shirdi", link: "Best-Sedan-Cab-in-Shirdi" },
        { place: "/images/keyword/22.jpg", text: "Ertiga Car Hire in Shirdi", link: "Ertiga-Car-Hire-in-Shirdi" },
        { place: "/images/keyword/23.jpg", text: "Innova Crysta on Rent in Shirdi", link: "Innova-Crysta-on-Rent-in-Shirdi" },
        { place: "/images/keyword/24.jpg", text: "Mini Bus on Rent in Shirdi", link: "Mini-Bus-on-Rent-in-Shirdi" },
        { place: "/images/keyword/25.jpg", text: "Tempo Traveller Hire in Shirdi", link: "Tempo-Traveller-Hire-in-Shirdi" },
    ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bus On Hire In Shirdi",
  "image": "https://www.saishirdicabs.com/assets/images/bus-on-hire-in-shirdi.webp",
  "description":
    "Book Bus On Hire In Shirdi with Sai Shirdi Cabs for comfortable, reliable, and affordable group transportation. We provide 14, 17, 25, and 32 seater buses, mini buses, and Tempo Travellers for Shirdi sightseeing, Sai Baba temple visits, pilgrimage tours, airport transfers, family trips, corporate travel, and outstation journeys. Enjoy well-maintained vehicles, experienced drivers, convenient pickup and drop facilities, and flexible rental options from Shirdi and Shirdi Airport.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Shirdi Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.saishirdicabs.com/bus-on-hire-in-shirdi"
  }
};





    return (
        <div>


<Helmet>
  <title>Bus On Hire In Shirdi | Tempo Traveller & Mini Bus Rental | +91 7776814559</title>

  <meta
    name="description"
    content="Hire 14, 17, 25 and 32 seater buses, mini buses and Tempo Travellers in Shirdi with Sai Shirdi Cabs. Get affordable group transport for Shirdi Darshan, sightseeing, airport transfers, pilgrimage tours, family trips and outstation travel."
  />

  <meta
    name="keywords"
    content="14 17 25 32 Seater Bus On Rent in Shirdi, 14 Seater Tempo Traveller On Rent, 17 Seater Tempo Traveller On Rent Shirdi, 25 Seater Tempo Traveller On Rent Shirdi, 32 Seater Tempo Traveller On Rent Shirdi, 14 17 25 32 Seater Mini Bus On Rent in Shirdi, Tempo Traveller Hire in Shirdi, Shirdi Airport Minibus Hire, tempo traveller on Rent in Shirdi Airport, 32 seater bus on rent in Shirdi, Bus On Hire In Shirdi, Bus Rental in Shirdi, Bus Hire in Shirdi, Mini Bus on Rent in Shirdi, Mini Bus Hire in Shirdi, Tempo Traveller Rental Shirdi, Tempo Traveller Booking Shirdi, 14 Seater Bus Rental Shirdi, 17 Seater Bus Rental Shirdi, 25 Seater Bus Rental Shirdi, 32 Seater Bus Rental Shirdi, 32 Seater Tempo Traveller Shirdi, Shirdi Group Transportation, Shirdi Darshan Bus Rental, Shirdi Sightseeing Bus Hire, Shirdi Pilgrimage Bus Rental, Shirdi Airport Bus Rental, Bus for Shirdi Tour, Shirdi Local Bus Rental, Outstation Bus Rental Shirdi, Shirdi Bus Booking, Affordable Bus Rental Shirdi, Luxury Bus Hire Shirdi, Shirdi Tempo Traveller with Driver"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/19.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Sai Shirdi Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Sai Shirdi Cabs</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Shirdi Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917776814559" className="pc-call">+91 7776814559 </a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919579032227" className="pc-call">+91 9579032227 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91917776814559 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917776814559 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@saishirdicabs.com" className="pc-email">
                                            booking@saishirdicabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Sai Shirdi Cabs</strong><br />
                                            Sai Mandir Lene, Near Hotel Sai Kanhaiya,
                                            Shirdi,Tel - Rahata,Dist Ahilyanagar,
                                            Maharashtra, India - 423109




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Busonhireinshirdi;